import {
    getSetting
    , getCustomize
    , getCustomizeValues
} from '../../../services/settings/service'

const state = () => ({
    setting: {
        load: true,
        value: null,
        national: null,
        international: null,
        many_key: false
    },
    authorizationsTime: '',
    processing: false
})

const mutations = {
    SET_DATA (state, { load = true,
        value = null,
        many_key = false,
        national = null,
        international = null })
    {
        state.setting = {
            load,
            value,
            national,
            international,
            many_key
        }
    },
    SET_AUTHORIZATIONS_TIME ( state, value ) {
        state.authorizationsTime = value
    },
    SET_PROCESSING (state, value = true) {
        state.processing = value
    }
}
const actions = {
    async getSettingOrCustomize({ commit }, key = 'No') {
        commit('SET_DATA', {})
        const values = {
            'No': getCustomize,
            'Nacional': getSetting,
            'Internacional': getSetting
        }
        if (values[key]) {
            if(key === 'No') {
                const { data: { days_without_tickets }} = await values[key]()
                return commit('SET_DATA', { load: false,
                    value: days_without_tickets
                })
            }

           const {
               data: {
                   national_tickets_days,
                   international_tickets_days
               }
           } = await values[key]()
            return commit('SET_DATA', { load: false,
                many_key: true,
                national: national_tickets_days,
                international: international_tickets_days
            })
        }
    },

    async getAuthorizationsTime({ commit }, { value }) {
        commit('SET_AUTHORIZATIONS_TIME', '')
        commit('SET_PROCESSING')
        const { data } = await getCustomizeValues({ value }).finally(() => commit('SET_PROCESSING', false))
        commit('SET_AUTHORIZATIONS_TIME', data)
    }
}
const getters = {
    getterSetting: (state) => state.setting
    , getterAuthorizationsTime: state => state.authorizationsTime
    , getterProcessing: state => state.processing
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
